import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { StorageService } from '../providers/storage.service';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { translateLoaderFactory } from '../translate';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ReportService } from '../providers/report.service';
import { SupplierProvider } from '../providers/supplier.service';
import { firebaseConfig } from '../config/firebase-config';
import { SupplierListModalComponent } from '../modules/supplier-selector/supplier-list-modal/supplier-list-modal';
import { SharedModule } from '../modules/shared.module';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp, {
      mode: 'md'
    }, 
{
  links: [
    { loadChildren: '../pages/gallery/gallery.module#GalleryPageModule', name: 'gallery', segment: 'gallery', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/image-preview/image-preview.module#ImagePreviewPageModule', name: 'image', segment: 'report/:reportId/image/:category/:id', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/list/list.module#ListPageModule', name: 'list-page', segment: 'reports', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'login', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/report/report.module#ReportPageModule', name: 'report', segment: 'report/:id', priority: 'low', defaultHistory: ['list-page'] },
    { loadChildren: '../pages/supplier-details/supplier-details.module#SupplierDetailsPageModule', name: 'supplier-details-page', segment: 'supplier/detail/:id', priority: 'low', defaultHistory: ['suppliers-list-page'] },
    { loadChildren: '../pages/supplier-list/supplier-list.module#SupplierListPageModule', name: 'suppliers-list-page', segment: 'suppliers', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/version/version.module#VersionPageModule', name: 'version-page', segment: 'version', priority: 'low', defaultHistory: [] }
  ]
}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (translateLoaderFactory),
        deps: [HttpClient]
      }
    }),
    SharedModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    SupplierListModalComponent
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    StorageService,
    ReportService,
    SupplierProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts